import { http } from "@/http";

export default {
  list() {
    return http.get("/api/v1/otas");
  },
  get(id) {
    return http.get(`/api/v1/otas/${id}`);
  },
  save(data) {
    return http.post("/api/v1/otas", data);
  },
  update(id, data) {
    return http.put(`/api/v1/otas/${id}`, data);
  },
};
